import Vue from 'vue';
import Vuex from 'vuex';

import { AuthStore, NoticeStore, pendoPlugin } from '@kasasa/fbase-components/lib';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fiId: null,
    configVersion: null,
    productMappingErrorMessage: null,
    productValidationResults: null,
    allConfigVersions: null,
  },
  mutations: {
    fiId(state, fiId) {
      state.fiId = fiId;
    },
    configVersion(state, configVersion) {
      state.configVersion = configVersion;
    },
    productMappingErrorMessage(state, message) {
      state.productMappingErrorMessage = message;
    },
    productValidationResults(state, results) {
      state.productValidationResults = results;
    },
    allConfigVersions(state, allConfigVersions) {
      state.allConfigVersions = allConfigVersions;
    },
  },
  modules: {
    auth: AuthStore,
    notices: NoticeStore,
  },
  plugins: [pendoPlugin],
});
